<template>
  <div class="auth-login max-w-md">
    <BaseBanner
      v-if="warnMsg"
      class="mb-4"
      :message="warnMsg"
      variant="warning"
      :show-close="false"
    />
    <div class="bambee-box">
      <figure class="image bambee-logo flex justify-center">
        <img
          src="/assets/images/logo/bambee.svg"
          alt="bambee-logo"
          class="w-3/5"
        />
      </figure>
      <h3 class="b-text is-22 is-bolder">
        {{ header }}
      </h3>
      <h3 class="b-text is-16 is-subheader">
        {{ subheader }}
      </h3>
      <slot />
    </div>
    <div class="my-4">
      <AuthAssistanceBanner />
    </div>
    <h3 class="b-text is-10 is-disclaimer">
      We take your data &amp; privacy seriously. We use
      {{ constants.ENCRYPTION_LEVEL }}-bit bank-level security.
    </h3>
    <div class="security-wrap">
      <img
        src="/assets/images/registration/security-logos/bbb-logo.png"
        alt="bbb"
      />
      <img
        src="/assets/images/registration/security-logos/norton-logo.png"
        alt="norton"
      />
      <img
        src="/assets/images/registration/security-logos/trustpilot-logo.png"
        alt="trustPilot"
      />
    </div>
  </div>
</template>

<script>
import { ENCRYPTION_LEVEL } from '@/constants/Security';
import { defineComponent, useRoute, useRouter } from '@nuxtjs/composition-api';
import { BaseBanner } from '@bambeehr/pollen';
import AuthAssistanceBanner from '@/components/banners/AuthAssistanceBanner.vue';

export default defineComponent({
  name: 'AuthLogin',
  components: {
    BaseBanner,
    AuthAssistanceBanner,
  },
  props: {
    header: {
      type: String,
      default: '',
    },
    subheader: {
      type: String,
      default: '',
    },
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const warnMsg = route.value.query?.warnMsg;

    // Reset the error message so it doesn't show up on refresh and is removed from the url
    if (warnMsg) {
      router.replace({ query: {} });
    }

    return {
      warnMsg,
      constants: {
        ENCRYPTION_LEVEL,
      },
    };
  },
});
</script>

<style lang="scss" scoped>
@import '~assets/css/shared.scss';

$light-2: #e9e8eb;
$dark-2: #7c7c7d;

.auth-login {
  text-align: center;
}

.bambee-box {
  background-color: $white;
  border: 1px solid $light-2;
  border-radius: 5px;
  margin: 0 auto;
  padding: 32px;
  text-align: center;
}

h3.is-subheader {
  color: $dark-2;
}

.is-disclaimer {
  margin-top: 12px;
}

.security-wrap {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: 12px;

  img {
    height: 21px;
  }

  img + img {
    margin-left: 1rem;
  }
}
</style>
